import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/core/telemetry/appInsights';

/** Tracks a page view in Application Insights whenever the route changes. */
export function TelemetryRouteListener(): null {
  const location = useLocation();
  useEffect(() => {
    trackPageView({ name: location.pathname });
  }, [location.pathname]);
  return null;
}
